import useCommandFlowStore from "../../store/commandFlowStore";

export function createSetters({ setCurrentPrompt, incrementResetToken }) {
  return {
    setCurrentPrompt,
    incrementResetToken,
  };
}

export function resetState(setCurrentPrompt, incrementResetToken, initMessage) {
  const setOutput = useCommandFlowStore.getState().setOutput;
  const setInSession = useCommandFlowStore.getState().setInSession;
  setOutput(initMessage);
  setCurrentPrompt(null);
  setInSession(false);
  incrementResetToken();
}
